goog.provide("shadow.js.shim.module$src$svg$objects$bookmark_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$bookmark_svg");
shadow.js.shim.module$src$svg$objects$bookmark_svg = shadow.js.nativeProvides["src/svg/objects/bookmark.svg"] = shadow$bridge("src/svg/objects/bookmark.svg");
module$shadow_js_shim_module$src$svg$objects$bookmark_svg.default = shadow.js.shim.module$src$svg$objects$bookmark_svg;
